import React, {useEffect} from 'react';
import $ from "../../utils/datatables";
import {Link} from "react-router-dom";
import { toast } from 'react-toastify';
import moment from "moment";
import {GET_SELL_REQUESTS_URL} from "../../api";

const SellRequest = (props) => {

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#sell_request_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Loading sell requests</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                $.ajax(GET_SELL_REQUESTS_URL, {
                    type: 'GET',
                    headers: {
                        Authorization: token
                    },
                    success: function(res) {
                        const rawList = Array.isArray(res) ? res : (res?.results ?? res?.data ?? []);
                        const result = rawList.map((item) => ({ raw: item }));

                        callback({
                            recordsTotal: res?.count ?? result.length,
                            recordsFiltered: res?.count ?? result.length,
                            data: result
                        });
                    },
                    error: function(err) {
                        toast.error(err.statusText || 'Failed to load sell requests', {position: "top-right", autoClose: 5000});
                        callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
                    }
                });
            },
            columns: [
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" }
            ],
            columnDefs: [
                {
                    render: function(data) {
                        const u = data?.user;
                        if (!u) return '—';
                        if (typeof u === 'object') {
                            const n = [u.first_name, u.last_name].filter(Boolean).join(' ');
                            return n || u.username || u.id || '—';
                        }
                        return `#${u}`;
                    },
                    targets: 0
                },
                {
                    render: function(data) {
                        const to = data?.trade_offer;
                        if (!to) return '—';
                        const agg = to?.aggregator;
                        const crop = to?.crop;
                        const label = agg?.name ?? agg?.pacra_id ?? `#${to?.id ?? '—'}`;
                        return crop?.name ? `${label} · ${crop.name}` : label;
                    },
                    targets: 1
                },
                {
                    render: function(data) {
                        const p = data?.product;
                        return (p?.name ?? (typeof p === 'object' && p?.crop?.name) ?? '—');
                    },
                    targets: 2
                },
                {
                    render: function(data) {
                        const qty = data?.quantity;
                        const units = data?.units ?? 'kg';
                        return qty != null ? `${Number(qty).toLocaleString()} ${units}` : '—';
                    },
                    targets: 3
                },
                {
                    render: function(data) {
                        return data?.suggested_price != null ? Number(data.suggested_price).toLocaleString() : '—';
                    },
                    targets: 4
                },
                {
                    render: function(data) {
                        const statusMap = {
                            PENDING: '<span class="badge bg-warning text-dark">Pending</span>',
                            ACCEPTED: '<span class="badge bg-success text-white">Accepted</span>',
                            REJECTED: '<span class="badge bg-danger text-white">Rejected</span>',
                            FLAGGED: '<span class="badge bg-info text-white">Flagged</span>'
                        };
                        return statusMap[data?.status] ?? (data?.status ?? '—');
                    },
                    targets: 5
                },
                {
                    render: function(data) {
                        return data?.date_created ? moment(data.date_created).format("Do MMM, YYYY") : '—';
                    },
                    targets: 6
                },
                {
                    render: function(data) {
                        return `<a href="#" class="nav-link view_sell_request"><i class="fa fa-eye"></i> View request</a>`;
                    },
                    targets: 7
                }
            ]
        });

        table.on('click', '.view_sell_request', function(e) {
            e.preventDefault();
            let rowData = table.row($(this).closest('tr')).data();
            if (rowData && rowData.raw && rowData.raw.id) {
                props.history.push(`/sell_request/${rowData.raw.id}`);
            }
            return false;
        });
    }, [props.history, token]);

    const reloadTable = () => {
        if ($.fn.DataTable.isDataTable('#sell_request_table')) {
            $('#sell_request_table').DataTable().ajax.reload(null, false);
        }
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Sell Requests</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Sell Requests</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Sell Requests</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="sell_request_table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th className="wd-12p">User</th>
                                            <th className="wd-15p">Trade Offer</th>
                                            <th className="wd-12p">Product</th>
                                            <th className="wd-10p">Quantity</th>
                                            <th className="wd-10p">Suggested Price</th>
                                            <th className="wd-10p">Status</th>
                                            <th className="wd-12p">Date Created</th>
                                            <th className="wd-10p">Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SellRequest;
